export default theme => ({
    topBar: {
        position: 'fixed',
        width: '100%',
        zIndex: 100,
        height: '74px',
        overflow: 'hidden',
        borderBottom: ' 1px solid #e0e0e0',
        background: '#fff',
        '-mozBoxShadow': '1px 1px 5px #ccc',
        '-webkitBoxShadow': '1px 1px 5px #ccc',
        boxShadow: '1px 1px 5px #ccc',
    },

    secondaryMenu: {
        background: '#000',
        '& a': {
            padding: '2px 0',
            color: '#fff',
        }
    },

    toolbar: {
        padding: 0,
        alignItems: 'stretch',
    },

    logoLink: {
        // flexGrow: 1,
    },

    menuList: {
        margin: 0,
        padding: 0
    }
});